export const FULLSCREEN_BUTTONS = Object.freeze({
  BACK: 'back',
  LOG_OUT: 'log_out',
});
